/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SvgFileMetadataUpdate } from '../../models/svg-file-metadata-update';

export interface UpdateSvgAssociation$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The uid of the selected svg
 */
  svgUid: string;
  
    /**
     * The SVG file metadata update object
     */
    body: SvgFileMetadataUpdate
}

export function updateSvgAssociation(http: HttpClient, rootUrl: string, params: UpdateSvgAssociation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateSvgAssociation.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('svgUid', params.svgUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateSvgAssociation.PATH = '/stations/{uid}/svg/{svgUid}';
